import { Component, Input } from '@angular/core';
import { MaInsuranceTravelRZCP } from '@shared/models/ma-insurance';

@Component({
    selector: 'app-ma-insurance-travel-rzcp',
    templateUrl: './ma-insurance-travel-rzcp.component.html',
    styleUrls: ['./ma-insurance-travel-rzcp.component.scss'],
    standalone: false
})
export class MaInsuranceTravelRZCPComponent {
    @Input() maInsurance: MaInsuranceTravelRZCP;


    constructor() {

    }

    protected moduleNameByTarrif(tarrifName: string): string {
        if (tarrifName.includes('LN')) {
            return 'Liečebné náklady';
        }

        if (tarrifName.includes('SB')) {
            return 'Standard Business';
        }

        if (tarrifName.includes('OB')) {
            return 'Optimal Business';
        }

        if (tarrifName.includes('B') || tarrifName.includes('BB')) {
            return 'Basic Business';
        }

        return tarrifName;
    }
}
